<template>
    <div>
        <h2 class="h2">Soubory</h2>
        <file-list/>
        <div class="elementary-section__controls button-fix">
            <custom-button @click="saveFiles" small outline>Vložit soubory</custom-button>
        </div>

        <div class="m--t-5">
            <h2 class="h2">Karta jednotky</h2>
            <file-card/>
        </div>
    </div>
</template>

<script>
import FileList from './FileList';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import FilePickerDialog from 'domovio-core/src/modules/MediaModule/components/File/FilePickerDialog';
import FileCard from '@/modules/ProjectModule/modules/UnitModule/components/File/FileCard';

export default {
    name:       'FileContainer',
    components: {FileCard, CustomButton, FileList},
    methods:    {
        saveFiles() {
            this.$modal.show(FilePickerDialog, {
                multipleSelect: true,
                onSelect:       ({fileIds}) => {
                    this.$store.dispatch('projects/project/units/unit/updateFiles', {fileIds, connected: true})
                        .catch((message) => this.$dmv.notifyError(message));
                    this.$modal.hideAll();
                },
                onCancel:       () => this.$modal.hideAll(),
            }, defaultModalParameters({
                maxWidth: 700,
                width:    700,
            }));
        }
    }
}
</script>
